import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { Breadcrumbs } from '../../../../AbstractElements';
import EditUser from './EditUser';
import i18n from '../../../../i18n';


const UserProfile = () => {

    const { id } = useParams();

    return (
        <Fragment>
            <Breadcrumbs mainTitle={i18n.t('Dashboard_Breadcrumb_UserEdit')} parent={i18n.t('Dashboard_Breadcrumb_Users')} title={i18n.t('Dashboard_Breadcrumb_UserEdit')} />
            <Container fluid={true}>
                <div className="edit-profile">
                    <Row>
                        <Col xl="12">
                            <EditUser userid={id} />
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};
export default UserProfile;
